import { common, aliyun } from '@/agent'
import LocalStorage from '@/utils/localStorage'

export const actions = {
  // 登录
  async Login (context, body) {
    const result = await common.login(body)
    if (result && result.code === 100) {
      // context.commit('SET_USER_INFO', result.data.user)
      context.commit('SET_TOKEN', result.data)
      LocalStorage.set('token', result.data)
    }
  },
  // 获得底部tab列表
  async GetTabList (context) {
    return new Promise(function (resolve, reject) {
      common.getUserTabs().then(res => {
        if (res && res.code === 100) {
          let tabList = res.data.filter(item => {
            item.icon = aliyun.getAliyunAddress(item.icon)
            item.activeIcon = aliyun.getAliyunAddress(item.activeIcon)
            item.router = item.appName
            return item.appName
          })
          console.log(tabList)
          context.commit('SET_TABS_LIST', tabList)
          LocalStorage.set('tabs_list', JSON.stringify(tabList))
          resolve(tabList)
        } else {
          reject(res)
        }
      })
    })
  }
}
